import {useState} from 'react';
import {
    Badge,
    Button,
} from '@mantine/core';
import {FiFilter} from 'react-icons/fi';

import {FilterDrawer} from '../drawers/FilterDrawer';
import {useApplicationScreenshotsFilter} from '../hooks/useApplicationScreenshotsFilter';

export const FilterRecordsButton = () => {
    const [opened, setOpened] = useState(false);
    const {activeCount} = useApplicationScreenshotsFilter();

    return (
        <>
            <div style={{position: 'relative'}}>
                <Button
                    variant='outline'
                    leftSection={<FiFilter size={16}/>}
                    onClick={() => setOpened(true)}
                    data-testid='filter-records-button'
                >
                    Filter
                </Button>
                {/* A filter you cannot see is a filter you forget is on. */}
                {activeCount > 0 && (
                    <Badge
                        size='xs'
                        variant='filled'
                        color='blue'
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                        data-testid='filter-active-count'
                    >
                        {activeCount}
                    </Badge>
                )}
            </div>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
